import './ActiveSubstations.css';
import React, { useMemo, useState } from "react";
import ActiveSubstationsModalContent from './ActiveSubstationsModalContent';
import DynamicModal from '../../components/Modal/DynamicModal';

const ActiveSubstations = ({ clickInfo, selectedFeature }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const flatSelectedFeatures = useMemo(() => {
        if (!Array.isArray(selectedFeature)) return [];
        return selectedFeature.flat().filter(Boolean);
    }, [selectedFeature]);

    const selectedVod = useMemo(() => {
        return (
            flatSelectedFeatures.find((feature) => {
                const featureId = feature?.id || "";
                return featureId.includes("vod");
            }) || null
        );
    }, [flatSelectedFeatures]);

    const clickedVod = useMemo(() => {
        return clickInfo?.layer?.id === "vod-layer" ? clickInfo : null;
    }, [clickInfo]);

    const activeVod = selectedVod || clickedVod;

    const vodId = useMemo(() => {
        return activeVod?.object?.id || activeVod?.id || null;
    }, [activeVod]);

    const pripadnostVodu = useMemo(() => {
        return (
            activeVod?.object?.properties?.pripadnost_vodu ??
            activeVod?.properties?.pripadnost_vodu ??
            null
        );
    }, [activeVod]);

    return (
        <div className="active-substations-div-sidebar">
            <div className="active-substations-sidebar-card">
                <div className="active-substations-sidebar-header">
                    <div>
                        <h3 className="active-substations-title">Očitavanje brojila TS</h3>
                        <p className="active-substations-subtitle">
                            Pregled podataka za odabrani vod i pripadajuće trafostanice
                        </p>
                    </div>
                </div>

                <div className="active-substations-status-row">
                    <div className={`active-substations-badge ${pripadnostVodu ? 'is-active' : 'is-inactive'}`}>
                        <span className="active-substations-badge-dot"></span>
                        {pripadnostVodu ? `Vod izabran${vodId ? ` • ${vodId}` : ''}` : 'Nema izabranog voda'}
                    </div>

                    {pripadnostVodu ? (
                        <button
                            type="button"
                            className="active-substations-open-btn"
                            onClick={openModal}
                        >
                            Prikaži podatke
                        </button>
                    ) : (
                        <div className="active-substations-empty-message">
                            Izaberi vod na mapi ili iz liste selektovanih objekata.
                        </div>
                    )}
                </div>
            </div>

            <DynamicModal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                title="Očitavanje brojila TS"
                mainContent={
                    <ActiveSubstationsModalContent
                        isOpen={isModalOpen}
                        vodId={vodId}
                        pripadnostVodu={pripadnostVodu}
                    />
                }
                footerContent={
                    <button onClick={closeModal} className="app-btn app-btn-secondary">
                        Zatvori
                    </button>
                }
                customHeight="85vh"
                customWidth="75vw"
                customZIndex={1000}
            />
        </div>
    );
};

export default ActiveSubstations;